export const environment = {
  production: true,
  domain: 'login.admaxhub.com',
  apiUrl: 'https://amh-api-gateway-fe-1r72n2y7.an.gateway.dev/api/v1',
  API_KEY: 'AIzaSyDYHssjk3UgLxTfgtGUosGp60oMktKrouU',
  appName: 'AdMax Hub - Login',
  geoapifyApiKey: '2825cff5a6fc4254838f14e73c1a9ecb',
  googleClientId: '137564986543-6t7db48s2bdisnhhvfgiuvdvg7goscas.apps.googleusercontent.com',
  features: {
    auth: true,
    dsp: false,
    ssp: false
  },
  allowedRoutes: ['/login', '/forgot-password', '/reset-password', '/'],
  redirectAfterLogin: {
    dsp: 'https://dsp.admaxhub.com',
    ssp: 'https://ssp.admaxhub.com'
  }
};
